export function random(max: number) {
  return Math.floor(Math.random() * max);
}

// Threshold should be a float 0.00 - 1.00
export function percent(threshold: number) {
  const limit = Math.min(threshold, 1) * 100;
  const num = random(100);

  return num <= limit;
}

export function jitter(duration: number, amount: number) {
  const delta = random(duration * amount);
  const coinFlip = random(2);

  return (coinFlip) ? duration - delta : duration + delta;
}

// @link https://stackoverflow.com/a/2117523/1349384
export function uuidv4() {
  // @ts-ignore
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
